/**
 * @generated SignedSource<<061cbe321f08ae1f8c1bcdbd4519f6a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Header_header$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Header_navigation">;
  readonly " $fragmentType": "Header_header";
};
export type Header_header$key = {
  readonly " $data"?: Header_header$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header_header">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header_header",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Header_navigation"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "3cbd0ed1527c06c113a0590dd46a7a7c";

export default node;
